import React from "react";
import BsModal from "../../Misc/BsModal";
import JsonformTableRender from "../../Misc/JsonformTableRender";
export default class JournalTupleItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
  }
  toggleModal = () => {
    this.setState((state) => {
      return { showModal: !state.showModal };
    });
  };
  render() {
    let data = this.props.tuple || {};
    let date = new Date(this.props.timestamp) || {};

    return (
      <React.Fragment>
        <BsModal center show={this.state.showModal} onClose={this.toggleModal}>
          <h5 className="mb-5">Информация о записи:</h5>
          <table className="table">
            <tbody>
              <tr>
                <td>Журнал</td>
                <td>{this.props.journallabel}</td>
              </tr>
              <tr>
                <td>Автор</td>
                <td>{this.props.username}</td>
              </tr>
              <tr>
                <td>Дата и время</td>
                <td>{date.toLocaleString()}</td>
              </tr>
              <tr>
                <td>Регулируемая сложность</td>
                <td>{this.props.bits}</td>
              </tr>

              <tr>
                <td>Хэш-значение заголовка кортежа</td>
                <td>{this.props.id}</td>
              </tr>
              <tr>
                <td>Хэш-значение заголовка предыдущего кортежа</td>
                <td>{this.props.previous}</td>
              </tr>
              <tr>
                <td>Хэш-значение кортежа</td>
                <td>{this.props.hash}</td>
              </tr>
            </tbody>
          </table>
        </BsModal>
        <div className="card mt-4">
          <div className="p-5 bg-light d-flex align-items-center justify-content-between">
            <div>{date.toLocaleString()}</div>
            <div>{this.props.username}</div>
          </div>

          <div className="p-2">
            <JsonformTableRender form={this.props.fields} data={data} />
          </div>
        </div>
      </React.Fragment>
    );
  }
}
